import { Box3 } from 'three';
export default (object, actualRadius, initialScale) => {
    const boundingBox = new Box3().setFromObject(object);
    const inWorldRadius = boundingBox.max.x;
    const divider = inWorldRadius / actualRadius;
    const scalingFactor = initialScale / divider;
    return [scalingFactor, scalingFactor, scalingFactor];
};
